var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-mount="items" class="sortable-list"></div>\n\n<div data-mount="fixed-items" class="sortable-list"></div>\n';
}
return __p;
};
